import React, { createContext, useState, useContext } from "react";

// Create a context for modal
const ModalContext = createContext();

// Modal provider component
export const ModalProvider = ({ children }) => {
  const [currentModal, setCurrentModal] = useState(null); // state to track the current modal
  const [modalCallback, setModalCallback] = useState(null); // state to track modal callback

  // Enhanced setCurrentModal that accepts an optional callback
  const setCurrentModalWithCallback = (modal, callback = null) => {
    setCurrentModal(modal);
    setModalCallback(() => callback); // Wrap in function to store callback properly
  };

  // Function to close the modal
  const closeModal = () => {
    setCurrentModal(null); // Close the modal by resetting currentModal to null
    setModalCallback(null); // Clear the callback
  };

  return <ModalContext.Provider value={{ 
    currentModal, 
    setCurrentModal: setCurrentModalWithCallback, 
    closeModal,
    modalCallback
  }}>{children}</ModalContext.Provider>;
};

// Custom hook to use modal context
export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
